

import React from 'react';
import type { IconProps } from '../types';
import logo from './../../../../../app/assets/vuelogo.png';


export const LoadingOHIFMark = (props: IconProps) => (
  <img
    src={logo}
    width={84}
    height={80}
    alt="Loading"
    {...props}
  />
);


export default LoadingOHIFMark;